import { BaseService } from '../api';
import { FilteredRequest } from '../common';
import { CategoriesRequest, ListFinalWithTypes } from './asset.service.interfaces';
import { AssetCategory } from './interfaces';

export class S2CAssetService extends BaseService {
  listS2CCategories(req: FilteredRequest<CategoriesRequest> = {}) {
    return this.get<AssetCategory[]>(`${this.apiUrl}/assets/v1/asset-category/s2c-sub`, req);
  }

  listS2CFinalType(req: ListFinalWithTypes) {
    return this.get<AssetCategory[]>(`${this.apiUrl}/assets/v1/asset-category/final-with-types`, req);
  }
}
